const footerCols = [
  {
    title: "热门栏目",
    links: ["娱乐八卦", "影视综艺", "音乐时尚", "社会热点", "生活趣闻"],
  },
  {
    title: "站点导航",
    links: [
      { label: "今日热门榜", href: "#today" },
      { label: "本周排行", href: "#week" },
      { label: "爆款话题", href: "#features" },
      { label: "栏目分类", href: "#columns" },
      { label: "关于我们", href: "#about" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary-100/70 border-t border-secondary-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950 whitespace-nowrap">
                吃瓜<span className="text-primary-600">精选</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              吃瓜精选热门榜与本周排行每日滚动更新，聚合全网热度TOP事件与爆款话题，帮你一榜看尽当日焦点，随时掌握最新鲜的瓜田动态。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-instagram-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#home"
                  aria-label="社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerCols.map((col) => (
            <nav key={col.title} className="md:col-span-2">
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => {
                  const label = typeof link === "string" ? link : link.label;
                  const href = typeof link === "string" ? "#today" : link.href;
                  return (
                    <li key={label}>
                      <a href={href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                        {label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold text-foreground-950">站点说明</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              吃瓜精选致力于客观呈现公开平台的高话题度事件热度，内容仅供信息参考，不代表本站立场。
            </p>
            <a
              href="#home"
              className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              回到顶部
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 吃瓜精选 · 专注每日热门事件与爆款话题聚合
          </p>
          <p className="text-xs text-foreground-500">一榜看尽当日焦点 · 吃瓜精选热门榜</p>
        </div>
      </div>
    </footer>
  );
}